'use client'

import { useGetBrandsQuery } from '@/api/brands/queries/get-brands-query'

/**
 * Returns true when the user has not yet completed brand onboarding
 * (i.e. they have no real, non-empty brand).
 *
 * Use this hook to gate UI that should only appear after onboarding:
 * - Sidebar overlay
 * - Prompt suggestions
 * - "Start another task" banner
 * - Cmd+K composer availability
 */
export function useIsUserInOnboarding(): boolean {
    const { data: brands } = useGetBrandsQuery()
    return !(brands?.some((brand) => !brand.emptyBrand) ?? false)
}
